import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ModalWrapper from 'components/ModalWrapper';

const AboutDialog = ({ open, setOpen }) => {
  const handleClose = () => setOpen(false);

  return (
    <Dialog open={open} onClose={handleClose}>
      <ModalWrapper className='about-us'>
        <DialogTitle>About Us</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Shirtly is a print-on-demand app that connects directly with your
            Shopify, Etsy, WooCommerce, BigCommerce, BigCartel and other
            platform stores. This allows you to create an entire catalog of
            products without spending tons of money on inventory. Shirtly
            partners with fulfillment companies who customize all its offered
            products for your online stores and ships them finished directly to
            your customers anywhere in the world.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='primary'>
            Ok
          </Button>
        </DialogActions>
      </ModalWrapper>
    </Dialog>
  );
};

export default AboutDialog;
